module.exports = __webpack_public_path__ + "img/dishub-kalsel.47c31d50.png";